import { NativeHealthState } from "@/utils/healthBridgeSchemas";

export function healthSyncMessage(state: NativeHealthState | null): string | null {
  if (!state) return null;
  if (state.status === "recovery_required") {
    return "Não foi possível confirmar a continuidade dos envios. Seus dados pendentes estão preservados. Entre em contato com o suporte da Omint.";
  }
  if (state.status !== "paused" && state.status !== "error") return null;
  const messages: Record<string, string> = {
    unauthorized: "Sua sessão expirou ou não é mais válida. Entre novamente no app para retomar o envio.",
    network_error: "Não foi possível conectar à Omint. Verifique sua conexão e tente sincronizar novamente.",
    timeout: "A conexão demorou mais que o esperado. Os dados continuam salvos para uma nova tentativa.",
    server_error: "O serviço da Omint está temporariamente indisponível. Tente novamente mais tarde.",
    rate_limited: "O serviço pediu uma pausa nos envios. Aguarde um pouco antes de tentar novamente.",
    consent_required: "O envio está pausado. Autorize a integração para continuar.",
    authorization_denied: "Autorize o acesso aos dados de saúde nas configurações do aparelho para continuar.",
    health_read_failed: "Não foi possível ler parte do histórico do aparelho. Tente sincronizar novamente.",
    unconfirmed_upload:
      "Ainda não foi possível confirmar o último envio. Os dados foram preservados e serão conferidos na próxima sincronização.",
    invalid_sync_state:
      "Não foi possível conferir o último envio com a Omint. Tente novamente; se o problema continuar, contate o suporte."
  };
  return (
    messages[state.sync.lastErrorCode || ""] ||
    (state.status === "paused"
      ? "O envio está pausado. Seus dados pendentes permanecem salvos no aparelho."
      : "Não foi possível concluir o envio. Tente novamente; se o problema continuar, contate o suporte da Omint.")
  );
}

export function healthStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    unavailable: "Indisponível",
    disconnected: "Desconectado",
    denied: "Acesso negado",
    partial: "Acesso parcial",
    syncing: "Sincronizando",
    connected: "Conectado",
    paused: "Pausado",
    error: "Atenção",
    recovery_required: "Recuperação necessária"
  };
  return labels[status] || "Desconectado";
}

export function healthSyncTitle(state: NativeHealthState | null): string {
  if (state?.status === "paused") return "Envio pausado";
  if (state?.status === "recovery_required") return "Envio aguardando recuperação";
  if (state?.status === "error") return "Envio interrompido";
  return "Sincronização dos dados de saúde";
}

export function healthSyncProgress(state: NativeHealthState | null): string {
  return `${Math.round(state?.sync.progress ?? 0)}%`;
}
